import { render } from "./AccountSwitcher.vue?vue&type=template&id=4cd25751&scoped=true"
import script from "./AccountSwitcher.vue?vue&type=script&lang=js"
export * from "./AccountSwitcher.vue?vue&type=script&lang=js"

import "./AccountSwitcher.vue?vue&type=style&index=0&id=4cd25751&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd25751"]])

export default __exports__